export class RenderableFactory {
    static register(facetType, renderableType) {
        if (this.registry.has(facetType.typestatic)) {
            throw new Error(`RenderableFactory.register: facet type ${facetType.typestatic} already registered`);
        }
        if (renderableType.facetType !== undefined) {
            throw new Error(`RenderableFactory.register: renderable type ${String(renderableType)} already registered`);
        }
        this.registry.set(facetType.typestatic, renderableType);
        renderableType.facetType = facetType;
    }
    static getFacetTypes() {
        return Array.from(this.registry.keys());
    }
    static hasByInstance(facet) {
        return this.registry.has(facet.constructor.typestatic);
    }
    static create(facet, model) {
        const RenderableClass = this.registry.get(facet.constructor.typestatic);
        if (RenderableClass !== undefined) {
            return new RenderableClass(model);
        }
        throw new Error(`Renderable facet ${facet.type} is not implemented`);
    }
}
RenderableFactory.registry = new Map();
